// messageCenter/textEditor.js — the text editor of the message center forms (new ticket incl. quick report, comment
// box, notice form): the live editor (topoLiveEditor), configured as in the overlays (overlayAdmin/infoTextEditor.js),
// with the message center entities passed in. One place, so all three fields stay alike.
// raw: the raw switch below the field (stored value as text); superusers only for now, decided by the page
// (data-permissions editorRaw / data-editor-raw on #quickReport); later its own permission (plan jsplugin_topoeditor,
// phase raw-debug).
import { str } from '../i18n/str.js';
import { createTopoLiveEditor } from '../topoLiveEditor/topoLiveEditor.js';

export function createTextEditor({ entities, rows, placeholder = '', raw = false }) {
    return createTopoLiveEditor({
        value: '', entities, rows, placeholder, raw,
        labels: {
            close: str('CLOSE_STR'), save: str('EDITOR_SAVE'), ok: str('EDITOR_OK'), remove: str('REMOVE'),
            edit: str('EDIT'), document: str('DOCUMENT'), unpublished: str('DOC_LINK_UNPUBLISHED'),
            raw: 'Raw',   // TODO i18n EDITOR_RAW
        },
    });
}
